export default __webpack_public_path__ + "static/media/rnr-sports-table-16.efdd452d.webp";